import { Link } from "react-router-dom";
import { Mail, Phone, Globe } from "lucide-react";
import { NAV_LINKS, SERVICES, CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_TEL } from "@/data/content";
import { useAnchorNav } from "@/lib/nav";
import { Logo } from "@/components/Logo";

const Footer = () => {
  const go = useAnchorNav();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-navy">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-4 font-display text-sm font-semibold text-cream/80">
              Digitalt som driver företag framåt.
            </p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-cream/50">
              Svensk digitalbyrå för hemsidor, grafisk design och digital marknadsföring – samlat på ett ställe.
            </p>
          </div>

          <nav aria-label="Sidfot – snabblänkar">
            <h2 className="font-display text-sm font-bold uppercase tracking-widest text-cream/40">Snabblänkar</h2>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={`/${l.href}`}
                    data-testid={`footer-link-${l.id}`}
                    onClick={(e) => go(e, l.id)}
                    className="text-sm text-cream/70 transition-colors hover:text-orange"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Sidfot – tjänster">
            <h2 className="font-display text-sm font-bold uppercase tracking-widest text-cream/40">Tjänster</h2>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {SERVICES.map((s) => (
                <li key={s.title}>
                  <a
                    href="/#tjanster"
                    onClick={(e) => go(e, "tjanster")}
                    className="text-sm text-cream/70 transition-colors hover:text-orange"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-display text-sm font-bold uppercase tracking-widest text-cream/40">Kontakt</h2>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  data-testid="footer-email-link"
                  className="flex items-center gap-2.5 text-sm text-cream/70 transition-colors hover:text-orange"
                >
                  <Mail size={16} className="shrink-0 text-teal" aria-hidden="true" />
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${CONTACT_PHONE_TEL}`}
                  data-testid="footer-phone-link"
                  className="flex items-center gap-2.5 text-sm text-cream/70 transition-colors hover:text-orange"
                >
                  <Phone size={16} className="shrink-0 text-teal" aria-hidden="true" />
                  {CONTACT_PHONE}
                </a>
              </li>
              <li>
                <Link to="/" className="flex items-center gap-2.5 text-sm text-cream/70 transition-colors hover:text-orange">
                  <Globe size={16} className="shrink-0 text-teal" aria-hidden="true" />
                  tillvia.se
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs text-cream/40">© 2026 Tillvia. Alla rättigheter förbehållna.</p>
          <div className="flex items-center gap-6">
            <Link
              to="/integritetspolicy"
              data-testid="link-integritetspolicy"
              className="text-xs text-cream/50 transition-colors hover:text-orange"
            >
              Integritetspolicy
            </Link>
            <Link
              to="/cookiepolicy"
              data-testid="link-cookiepolicy"
              className="text-xs text-cream/50 transition-colors hover:text-orange"
            >
              Cookiepolicy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
